var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSocialNet24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.002,
    viewBox: "0 0 16 16.002",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_social_net24x24",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "collaboration",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25194",
    "data-name": "Group 25194",
    transform: "translate(6.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25193",
    "data-name": "Group 25193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46174",
    "data-name": "Path 46174",
    d: "M193.6,0A1.613,1.613,0,0,0,192,1.627a1.6,1.6,0,1,0,3.193,0A1.613,1.613,0,0,0,193.6,0Z",
    transform: "translate(-191.996)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25196",
    "data-name": "Group 25196",
    transform: "translate(5.603 3.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25195",
    "data-name": "Group 25195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46175",
    "data-name": "Path 46175",
    d: "M171.46,104H171.4l-.057.028a2.086,2.086,0,0,1-1.889,0l-.057-.028h-.06A1.343,1.343,0,0,0,168,105.356v1.627a.8.8,0,0,0,.8.813h3.193a.8.8,0,0,0,.8-.813v-1.627A1.343,1.343,0,0,0,171.46,104Z",
    transform: "translate(-168 -104)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25198",
    "data-name": "Group 25198",
    transform: "translate(11.951 8.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25197",
    "data-name": "Group 25197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46176",
    "data-name": "Path 46176",
    d: "M361.594,255.1a1.613,1.613,0,1,0,1.137.482,1.627,1.627,0,0,0-1.137-.482Z",
    transform: "translate(-359.94 -255.1)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25200",
    "data-name": "Group 25200",
    transform: "translate(11.206 12.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25199",
    "data-name": "Group 25199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46177",
    "data-name": "Path 46177",
    d: "M339.46,359.1H339.4l-.057.027a2.086,2.086,0,0,1-1.889,0l-.057-.027h-.06A1.343,1.343,0,0,0,336,360.456v1.627a.8.8,0,0,0,.8.813h3.193a.8.8,0,0,0,.8-.813v-1.627a1.343,1.343,0,0,0-1.333-1.356Z",
    transform: "translate(-336 -359.1)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25202",
    "data-name": "Group 25202",
    transform: "translate(.745 8.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25201",
    "data-name": "Group 25201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46178",
    "data-name": "Path 46178",
    d: "M25.594,255.1a1.613,1.613,0,1,0,1.137.482,1.627,1.627,0,0,0-1.137-.482Z",
    transform: "translate(-23.94 -255.1)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25204",
    "data-name": "Group 25204",
    transform: "translate(0 12.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25203",
    "data-name": "Group 25203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46179",
    "data-name": "Path 46179",
    d: "M3.46,359.1H3.4l-.057.027a2.086,2.086,0,0,1-1.889,0l-.057-.027h-.06A1.343,1.343,0,0,0,0,360.456v1.627a.8.8,0,0,0,.8.813H3.992a.8.8,0,0,0,.8-.813v-1.627A1.343,1.343,0,0,0,3.46,359.1Z",
    transform: "translate(0 -359.1)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25206",
    "data-name": "Group 25206",
    transform: "translate(5.333 13.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25205",
    "data-name": "Group 25205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46180",
    "data-name": "Path 46180",
    d: "M165.3,392.54h0a.267.267,0,0,0-.349-.146h0a5.819,5.819,0,0,1-3.8.267l.25-.075a.27.27,0,0,0-.151-.518l-1.067.318a.012.012,0,0,0-.01.007.7.7,0,0,0-.07.037.116.116,0,0,0-.027.017.355.355,0,0,0-.067.089.318.318,0,0,0-.02.112,1.031,1.031,0,0,0,.027.108.026.026,0,0,0,0,.013l.533,1.037a.267.267,0,0,0,.356.116.276.276,0,0,0,.113-.366l-.216-.421a6.312,6.312,0,0,0,4.344-.241.283.283,0,0,0,.149-.356Z",
    transform: "translate(-159.996 -392.057)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25208",
    "data-name": "Group 25208",
    transform: "translate(10.139 2.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25207",
    "data-name": "Group 25207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46181",
    "data-name": "Path 46181",
    d: "M308.957,67.675a.267.267,0,0,0-.376,0l-.38.387a6.483,6.483,0,0,0-3.856-5.369.267.267,0,0,0-.349.142.276.276,0,0,0,.14.356,5.946,5.946,0,0,1,3.52,4.793l-.3-.3a.26.26,0,0,0-.376.007.274.274,0,0,0,0,.376l.8.813a.267.267,0,0,0,.376,0h0l.8-.813a.277.277,0,0,0,0-.387Z",
    transform: "translate(-303.976 -62.672)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25210",
    "data-name": "Group 25210",
    transform: "translate(1.597 1.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25209",
    "data-name": "Group 25209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46182",
    "data-name": "Path 46182",
    d: "M52.251,48.911a.233.233,0,0,0-.006-.047v-.014a.15.15,0,0,0-.027-.037.5.5,0,0,0-.03-.044.3.3,0,0,0-.053-.037.157.157,0,0,0-.03-.02l-1.067-.5a.261.261,0,0,0-.346.149.275.275,0,0,0,.126.346l.552.258A6.506,6.506,0,0,0,48,54.694a.267.267,0,1,0,.533,0,5.984,5.984,0,0,1,2.881-5.138l-.193.41a.267.267,0,1,0,.478.236l.533-1.132v-.007a.162.162,0,0,0,.013-.058.211.211,0,0,1,.01-.044.266.266,0,0,0-.005-.051Z",
    transform: "translate(-48 -48.194)",
    fill: "#999"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSocialNet24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_social_net24x24.3c7fe672c750a10a530b64a382cf6c1b.svg";